import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { strings } = useContext(LanguageContext);
  const [currentLang, setCurrentLang] = useState<"en" | "nl">("nl");

  const setLanguage = (lang: "en" | "nl") => {
    if (strings.getAvailableLanguages().includes(lang)) {
      strings.setLanguage(lang);
      setCurrentLang(lang);
    }
    return lang;
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const langParam = queryParams.get("lang") as "en" | "nl" | null;
    if (langParam && strings.getAvailableLanguages().includes(langParam)) {
      setLanguage(langParam);
    }
  }, [location]);

  return (
    <LanguageContext.Provider value={{ strings, setLanguage, currentLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
